export enum FraudActionTypeEnum {
    Decline=1,
    'Monitor'=2,
    'Monitor&Decline'=3
}

export namespace FraudActionTypeEnum {
    export function values() {
        return Object.keys(FraudActionTypeEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
export enum TypeOfValueEnum {
  'AmountGTZero' = 1,
  'AmountZero' = 2,
  'AmountValueAndZero&Decline' = 3,
}

export namespace TypeOfValueEnum {
  export function values() {
    return Object.keys(TypeOfValueEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export enum CardCategoryEnum {
    All= 1,
    ATM= 2,
    'POS&eCommerce' = 3,
    Online = 4,
    'ATM&POS(Excl eComm)' = 5,
    POS= 6,
    'International ATM' = 7,
    'International POS'= 8,
    'International POS and ATM'= 9
}

export namespace CardCategoryEnum {
    export function values() {
        return Object.keys(CardCategoryEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

export enum TypeOfVolumeEnum {
    None = 1,
    Sequence = 2,
    Volume = 3,
    Velocity = 4,
    'Volume-Multiple' = 5,
    'Time Difference' = 6
}

export namespace TypeOfVolumeEnum {
    export function values() {
        return Object.keys(TypeOfVolumeEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

export enum FraudDatasetEnum {
    Transaction = 1,
    Authorization = 2
}

export namespace FraudDatasetEnum {
    export function values() {
        return Object.keys(FraudDatasetEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
